import React from "react"
import { createRoot } from "react-dom/client";
import App from "../components/Team/App";

const PageAbout = ($) =>{

	// holds each timeline section that's on the page
	const cardsContainer = [...document.getElementsByClassName("js-side-panel-list")];

	return cardsContainer.forEach((container, containerId) => {
		const root = createRoot(container);
		const cardsArray = [...container.children];

		// passing down an array of each timeline card that is associated to each timeline section
		const props = [];
		cardsArray.map((card) => props.push({...card.dataset, containerId} ));

		if(container) {
			root.render(<App key={containerId} cards={props} containerId={containerId} tab="home" />);
		}
	})

};

export default PageAbout;
